import * as React from 'react'
import { inputColors } from '@disco/utils/colors'
import ColorPicker from '../../../../../ui/color-input/color-picker'
type Props = {
  value: {
    color: string
  }
  onSubmit: (color: any) => unknown
  colors?: readonly string[]
}
type State = {
  color: string
}
export class Color extends React.Component<Props, State> {
  state: State = {
    color: this.props.value.color,
  }

  render(): React.ReactElement<'div'> {
    const { onSubmit, value, colors = inputColors } = this.props
    return (
      <div className="color-picker__colors-dialog">
        <ColorPicker
          onChangeComplete={color => {
            this.setState({
              color: color.hex,
            })
            onSubmit(color)
          }}
          colors={colors}
          color={this.state.color}
        />
      </div>
    )
  }
}
export default Color
